export default "__VITE_ASSET__aP_gjtMX__"